import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { ResourceActualHoursSummaryBlocks2 } from '~/modules/resourcing/common/components/ResourceActualHoursSummaryBlocks';
import { getAllocationTotalsByPeriod } from '~/modules/resourcing/util';

const UserRoleActualsTimeLineRow = ({
  actualSummaryBlockPopupProps,
  actualsData,
  chartDisplayDateRange,
  chartDisplayPeriods,
  dataQeId,
  resourceAllocations,
  scale,
  topOffSet,
  user,
  userScheduleDetails
}) => {
  const topDefaultOffSet = (resourceAllocations?.length || 0) * 32 + 8;
  const cssStyles = useMemo(
    () => ({
      top: topOffSet || topDefaultOffSet
    }),
    [topOffSet, topDefaultOffSet]
  );

  return (
    <ResourceActualHoursSummaryBlocks2
      actualSummaryBlockPopupProps={actualSummaryBlockPopupProps}
      allocationPeriods={getAllocationTotalsByPeriod({
        allocations: resourceAllocations,
        chartDisplayDateRange,
        chartDisplayPeriods,
        userScheduleDetails
      })}
      chartDisplayPeriods={chartDisplayPeriods}
      positionAttributes={cssStyles}
      resourceUser={user}
      resourceUserActualTimePeriods={actualsData?.periods}
      scale={scale}
      dataQeId={dataQeId || 'UserRoleActualsRow'}
    />
  );
};

UserRoleActualsTimeLineRow.propTypes = {
  user: PropTypes.object,
  actualsData: PropTypes.object,
  scale: PropTypes.string,
  topOffSet: PropTypes.number,
  resourceAllocations: PropTypes.array,
  chartDisplayDateRange: PropTypes.object,
  chartDisplayPeriods: PropTypes.array,
  dataQeId: PropTypes.string,
  actualSummaryBlockPopupProps: PropTypes.object,
  userScheduleDetails: PropTypes.object.isRequired
};

export default UserRoleActualsTimeLineRow;
